export default __webpack_public_path__ + "static/media/HeroGifMobile.e369059a.png";